import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '../modules/crud';
import { Partner } from './partner.model';
import { Profile } from './profile.model';


@CwtModel({ name: 'location', path: 'location' })
export class Location extends ApiData {
    partner?: Partner;
    owners?: Profile[];
    name?: string;
    xPos?: number;
    yPos?: number;
    externalRef?: string;
}
